import BaseApi from './BaseApi'

class PatientService extends BaseApi {
  async list() {
    return this.axios.get('/v1/patients/')
  }

  async get(patientId) {
    return this.axios.get(`/v1/patients/${patientId}/`)
  }

  async listNotes(dependentId) {
    return this.axios.get('/v1/doctor-notes/', { params: { dependent_id: dependentId } })
  }

  async createNote(dependentId, note, showInChart = false) {
    return this.doRequest('post', '/v1/doctor-notes/', { dependent: dependentId, note, show_in_chart: showInChart })
  }

  async updateNote(noteId, note, showInChart, createdAt) {
    return this.doRequest('patch', `/v1/doctor-notes/${noteId}/`, { note, show_in_chart: showInChart, created_at: createdAt })
  }

  async deleteNote(noteId) {
    return this.axios.delete(`/v1/doctor-notes/${noteId}/`)
  }
}

export default PatientService
